module.exports = __webpack_public_path__ + "media/fonts/Lato-Bold-b84229dbca6a0a51f200030c9f85c838.woff2";